import { render, staticRenderFns } from "./CreateClient.vue?vue&type=template&id=3d763d1e&scoped=true&"
import script from "./CreateClient.vue?vue&type=script&lang=js&"
export * from "./CreateClient.vue?vue&type=script&lang=js&"
import style0 from "./CreateClient.vue?vue&type=style&index=0&id=3d763d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d763d1e",
  null
  
)

export default component.exports